import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { applyUserMessageWindowOpened } from '../../stateManagement/reducers/SidebarBlockSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';


export default function HelpingWindow() {
    const dispatch = useDispatch()
    const dialogRef = useRef<HTMLDivElement>(null)
    const isMessageWindowOpenned = useAppSelector(state => state.sidebar.isUserMessageWindowOpened)
    const navigate = useNavigate();
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const [isSmallWindow, setIsSmallWindow] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://yastatic.net/s3/frontend/forms/_/embed.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 576);
    }, [sideBarState, navigate])

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (!isMessageWindowOpenned && dialogRef.current && !dialogRef.current.contains(event.target)) {
                dispatch(applyUserMessageWindowOpened(false));
            }
        };

        if (isMessageWindowOpenned) {
            // Добавляем обработчик событий при монтировании компонента
            document.addEventListener('click', handleClickOutside);
        }

        // Удаляем обработчик событий при размонтировании компонента
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isMessageWindowOpenned, dispatch]);

    return (
        <>
            {isMessageWindowOpenned && <div className="callback-overlay callback-overlay-show" >
                <div className="dialog" ref={dialogRef}>
                    <iframe src="https://forms.yandex.ru/cloud/65c1cd372530c23417e32b64/?iframe=1" name="ya-form-65c1cd372530c23417e32b64"
                        width={isSmallWindow ? "360px" : "500px"}
                        id="yaForm"></iframe>
                    <div className="header">
                        <div className="close-button" onClick={() => {
                            dispatch(applyUserMessageWindowOpened(false))
                        }
                        }>×</div>
                    </div>
                </div>
            </div >}
        </>
    );
}